import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './UserSelector.css';

const UserSelector = ({ users = [], account_id }) => {
    const navigate = useNavigate();
    const [userImages, setUserImages] = useState({});

    useEffect(() => {
        // Check which user images exist
        const checkImages = async () => {
            const imageStatus = {};
            for (const user of users) {
                try {
                    const imageUrl = `https://cdn.eztiptap.com/user_photos/${account_id}/user_${user.user_id}.png`;
                    const response = await fetch(imageUrl);
                    imageStatus[user.user_id] = response.ok ? imageUrl : null;
                } catch (error) {
                    imageStatus[user.user_id] = null;
                }
            }
            setUserImages(imageStatus);
        };
        checkImages();
    }, [users, account_id]);

    const handleUserSelect = (user_id) => {
        navigate(`/${account_id}/me?user_id=${user_id}`);
    };

    const getInitial = (displayName) => {
        return displayName ? displayName.charAt(0).toUpperCase() : '?';
    };

    if (!users || users.length === 0) {
        return <div className="user-selector-error">No users available</div>;
    }

    return (
        <div className="user-selector-container">
            <div className="user-button-grid">
                {users.map((user) => (
                    <button
                        key={user.user_id}
                        className="user-select-button"
                        onClick={() => handleUserSelect(user.user_id)}
                    >
                        <div className="user-avatar">
                            {userImages[user.user_id] ? (
                                <img 
                                    src={userImages[user.user_id]} 
                                    alt="Profile" 
                                    className="user-image"
                                />
                            ) : (
                                <div className="user-letter-avatar">
                                    {getInitial(user.display_name)}
                                </div>
                            )}
                        </div>
                        <span className="user-name">
                            {user.display_name || `User ${user.user_id}`}
                        </span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default UserSelector; 